export default function internalSystemOptionsDirective() {
  return {
    template: require('./internal-system-options.html'),
    scope: {
      customerId: '<',
      department: '=',
      process: '=',
      function: '=',
      internalSystemOptions: '=',
      isEdit: '<',
    },
    controller: 'InternalSystemOptionsController',
    controllerAs: 'internalSystemOptionsVM',
    bindToController: true,
    replace: true,
  };
}
